// eslint-disable-next-line no-shadow
enum REQUEST_TYPE {
  STANDART = "STANDART",
  CONNECTOR = "CONNECTOR",
}

export default REQUEST_TYPE;
